import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ApiService } from '../api/api.service';

@Injectable({
  providedIn: 'root',
})
export class LogNavigationService {
  public BaseURL: string = `${environment.baseUrls.serviceURL}`;
  public requestData: object = {};
  constructor(private apiService: ApiService, private _http: HttpClient) {}
 
 
  LogNavigationActivities(payload: any): Observable<any> {
    return this.apiService.post<any>(this.BaseURL + '/cmt/user/navigation-activities', payload);
  }
}